/**
 * Defines various functions that manipulate different layout's visibility/occurance
 * @module Layout-Functions
 */

import { route } from "./constants";
import SectionHeader2 from "../app/sections/common/header/header2";

/**
 * Sets header section for the template according to current page
 * @param _path : URL for visible page
 * @returns : suitable Header section for current page
 */
export const setHeader = (_path: string) => {
    // Only using Header2 since we only have Home2 now
    return <SectionHeader2 />;
}